import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

declare global {
  interface Window {
    /** Tells the worker's inline failsafe that the bundle arrived (see entranceGuardHandler). */
    ckAnimateReady?: boolean
  }
}

/**
 * Entrance animations for `[ck-animate]` elements.
 *
 * On pages served by the worker these elements start hidden by CSS
 * (`html.ck-js [ck-animate]:not([data-ck-animated])`), so they never paint before we get here.
 * When an element's tween starts we stamp it `data-ck-animated`, which releases that rule and
 * leaves GSAP's inline opacity in charge.
 */
export default function animate() {
  window.ckAnimateReady = true
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

  document.querySelectorAll('[ck-animate]').forEach((element) => {
    const transition = element.getAttribute('ck-animate')
    const delay = parseFloat(element.getAttribute('ck-animate-delay') || '0.325')

    // Release the CSS guard only once the tween is actually running and GSAP's inline opacity
    // is in place. Doing it any earlier lets the element show for a few frames, because
    // ScrollTrigger strips inline styles while it measures the page on its first refresh.
    const onStart = () => element.setAttribute('data-ck-animated', '')

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: element,
        start: 'top bottom',
        end: 'bottom top',
      },
    })

    if (transition === 'fadeUp') {
      tl.fromTo(
        element,
        { opacity: 0, y: 30 },
        { opacity: 1, y: 0, duration: 1.2, delay, ease: 'expo.out', onStart }
      )
    } else {
      tl.fromTo(
        element,
        { opacity: 0 },
        { opacity: 1, duration: 1.4, delay, ease: 'expo.out', onStart }
      )
    }

  })
}
